const getDefaultAsset = (num) => {
  const assetList = new Array(num);
  const emptyAsset= {
    Asset: {
      '@odata.type': '#Model.TextAsset',
      AssetType: 'Text',
      Name: null,
      Text: '',
    },
    PinnedField: 'None',
  };
  assetList.fill(emptyAsset);
  return assetList;
};
export class AdStrengthRepository {
  constructor({
    edm,
    jsdata,
  }) {
    this.edm = edm;
    this.jsdata = jsdata;
  }

  fetchAdStrengthV2(ad, campaignId, adGroupId) {
    const params = {
      query: {
        entitySet: this.edm.currentAccount
          .Campaigns.$withKey(campaignId)
          .AdGroups.$withKey(adGroupId)
          .Ads['Default.GetAdStrengthAndActionItems']
          .$call({
            ad: {
              '@odata.type': '#Model.ResponsiveSearchAd',
              Type: 'ResponsiveSearch',
              adId: ad.Id,
              Headlines: ad.Headlines || getDefaultAsset(5),
              Descriptions: ad.Descriptions || getDefaultAsset(2),
            },
          })
          .toJSON(),
      },
    };
    const options = {
      cacheResponse: false,
    };
    return this.jsdata.Ad.findAll(params, options);
  }

  fetchAdStrength(ad) {
    const params = {
      query: {
        entitySet: this.edm.currentAccount
          .Ads['Default.GetAdStrengthAndActionItems']
          .$call({
            ad: {
              '@odata.type': '#Model.ResponsiveSearchAd',
              Type: 'ResponsiveSearch',
              adId: ad.Id,
              Headlines: ad.Headlines,
              Descriptions: ad.Descriptions,
            },
          })
          .toJSON(),
      },
    };
    const options = {
      cacheResponse: false,
    };
    return this.jsdata.Ad.findAll(params, options);
  }
}
